import { render, staticRenderFns } from "./CenterManageLogin.vue?vue&type=template&id=15054a88&scoped=true"
import script from "./CenterManageLogin.vue?vue&type=script&lang=js"
export * from "./CenterManageLogin.vue?vue&type=script&lang=js"
import style0 from "./CenterManageLogin.vue?vue&type=style&index=0&id=15054a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15054a88",
  null
  
)

export default component.exports